import React from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "../utils/router";

function RouteContainer() {
  return <RouterProvider router={router} />;
}

export default RouteContainer;
